var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-select",
    _vm._g(
      _vm._b(
        {
          directives: [
            {
              name: "loadMore",
              rawName: "v-loadMore",
              value: _vm.loadMoreFunc,
              expression: "loadMoreFunc",
            },
          ],
          staticStyle: { color: "#010517" },
          attrs: { "infinite-scroll-disabled": _vm.noMore },
          model: {
            value: _vm.currentVal,
            callback: function ($$v) {
              _vm.currentVal = $$v
            },
            expression: "currentVal",
          },
        },
        "el-select",
        _vm.$attrs,
        false
      ),
      _vm.$listeners
    ),
    [
      _vm._t("default", function () {
        return _vm._l(_vm.list, function (item) {
          return _c("el-option", {
            key: item.value,
            class: item.class,
            attrs: {
              value: item.value,
              label: item.label,
              disabled: _vm.itemDisabled(item),
            },
          })
        })
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }